var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuleMiniIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2819 4.54504L8.10734 0.0733652C8.27845 -0.0244551 8.48856 -0.0244551 8.65971 0.0733652L16.4852 4.54504C16.6586 4.64413 16.7656 4.8286 16.7656 5.02832V13.9717C16.7656 14.1714 16.6586 14.3559 16.4852 14.455L8.65971 18.9266C8.57414 18.9755 8.47884 19 8.38354 19C8.28825 19 8.19291 18.9755 8.10738 18.9266L0.281939 14.455C0.108488 14.3559 0.00146484 14.1714 0.00146484 13.9717V5.02832C0.00146484 4.82856 0.108488 4.64413 0.2819 4.54504ZM8.38354 1.19778L1.68003 5.02832L8.38354 8.8589L15.087 5.02832L8.38354 1.19778ZM15.6523 5.98752L8.94019 9.82304V17.4842L15.6523 13.6487V5.98752ZM7.8269 17.4842V9.82304L1.11475 5.98752V13.6487L7.8269 17.4842Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleMiniIcon);
export default __webpack_public_path__ + "static/media/moduleMiniIcon.8cdc77d86dc0149c0979831538838743.svg";
export { ForwardRef as ReactComponent };